import { render, staticRenderFns } from "./TechPurchaseContent.vue?vue&type=template&id=3f7d7d63&scoped=true"
import script from "./TechPurchaseContent.vue?vue&type=script&lang=js"
export * from "./TechPurchaseContent.vue?vue&type=script&lang=js"
import style0 from "./TechPurchaseContent.vue?vue&type=style&index=0&id=3f7d7d63&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7d7d63",
  null
  
)

export default component.exports